import { render, staticRenderFns } from "./Airbag.vue?vue&type=template&id=3c4a851c"
import script from "./Airbag.vue?vue&type=script&lang=js"
export * from "./Airbag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports